<script>
import { mapState } from "vuex";
// import carousel from "vue-owl-carousel2";
import moment from "moment";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ViewCustomerCheckersQueueInfoModal",
  data() {
    return {
      modalOpen: false,
      rejectModalOpen: false,
      imageViewerOptions: {
        navbar: false,
        title: false,
        toolbar: false,
        tooltip: false
      },
      rejectVodalFormBody: {
        rejectReason: ""
      }
    };
  },
  props: {
    currentCustomer: {
      type: Object,
      required: true
    },
    currentCustomerJson: {
      type: Object,
      required: true
    }
  },
  // components: { carousel },
  computed: {
    ...mapState(["customer", "branch"])
  },
  validations: {
    rejectVodalFormBody: {
      rejectReason: { required }
    }
  },
  methods: {
    rejectChange() {
      // -close more info modal
      this.closeModal();
      // -open reject modal
      this.openRejectModal();
    },
    rejectChangeFinal() {
      this.closeRejectModal();
      // -build reject payload
      // -dont forget to add reject reason to th reject payload

      let payload = {
        cqId: this.currentCustomer.cqId,
        cqJson: JSON.stringify(this.currentCustomerJson),
        cqType: this.currentCustomer.cqType,
        cqMode: "REJECTED",
        cqReason: this.rejectVodalFormBody.rejectReason,
        cqBankCode: this.$store.getters["user/getUserBankCode"],
        cqChecker: this.$store.getters["user/getUserId"]
      };

      this.$store.dispatch("branch/setRejectLoading", true, { root: true });
      this.$store
        .dispatch("customer/checkerAuthorizeCustomerCreate", payload, {
          root: true
        })
        .then(responseData => {
          this.$store.dispatch("branch/setRejectLoading", false, {
            root: true
          });
          if (responseData.responseCode === "00") {
            this.closeModal();

            this.$emit("authorizeSuccessful", responseData);
          }
        })
        .catch(error => {
          throw error;
        });
    },
    authorizeChange() {
      let payload = {
        cqId: this.currentCustomer.cqId,
        cqJson: JSON.stringify(this.currentCustomerJson),
        cqType: this.currentCustomer.cqType,
        cqMode: "AUTHORIZE",
        cqBankCode: this.$store.getters["user/getUserBankCode"],
        cqChecker: this.$store.getters["user/getUserId"]
      };
      // this.closeModal();

      this.$store
        .dispatch("customer/checkerAuthorizeCustomerCreate", payload, {
          root: true
        })
        .then(responseData => {

          if (responseData.responseCode === "00") {
            this.closeModal();

            this.$emit("authorizeSuccessful", responseData);
          }
        })
        .catch(error => {
          throw error;
        });
    },
    viewMoreCustomerInfo() {
      this.openModal();
    },
    calculateAge(dob) {
      return Math.trunc(moment().diff(dob, "years", true));
    },
    openModal() {
      this.modalOpen = true;
    },
    closeModal() {
      this.modalOpen = false;
    },
    openRejectModal() {
      this.rejectModalOpen = true;
    },
    closeRejectModal() {
      this.rejectModalOpen = false;
    }
  }
};
</script>

<template>
  <div>
    <!--        control-->
    <a
      @click="viewMoreCustomerInfo()"
      class="view-customer-info-btn"
      v-b-tooltip.hover.right
      title="View More Info"
    >
      <i class="bx bx-info-circle"></i>
    </a>
    <!--    control END-->

    <!--        actual modal-->
    <vodal
      :show="modalOpen"
      :width="400"
      :height="480"
      measure="px"
      animation="zoom"
      @hide="modalOpen = false"
      :closeOnClickMask="false"
      className="app-modal"
    >
      <div class="card">
        <div class="card-body">
          <!--          <h4 class="card-title mb-4">Customer Info</h4>-->
          <div>
            <div class="view-more-customer-info">
              <div class="view-more-customer-info-wrap">
                <div class="view-more-top">
                  <div class="row">
                    <div class="col-sm-12">
                      <p class="customer-bio">
                        <span class="customer-avatar">
                          <viewer
                            :title="false"
                            :options="imageViewerOptions"
                            :images="[currentCustomerJson.customerPicture]"
                          >
                            <img
                              :src="currentCustomerJson.customerPicture"
                              alt=""
                            />
                          </viewer>
                        </span>
                        <span class="customer-info">
                          <span class="name">{{
                            (currentCustomerJson.customerFirstName +
                              " " +
                              currentCustomerJson.customerMiddleName +
                              " " +
                              currentCustomerJson.customerLastName)
                              | firstCaseCapitalSpace
                          }}</span>

                          <!--                          <span class="age">-->
                          <!--                            {{ calculateAge(currentCustomerJson.customerDob) }} years-->
                          <!--                          </span>-->
                        </span>
                      </p>
                    </div>
                  </div>
                </div>

                <div class="view-more-base">
                  <div class="table-responsive">
                    <table class="table mb-0">
                      <tbody>
                        <tr>
                          <td>
                            <p class="view-more-base-tag">
                              BVN :
                            </p>
                          </td>
                          <td>
                            <p class="view-more-base-value">
                              {{ currentCustomerJson.customerBvn }}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p class="view-more-base-tag">
                              Customer Maker :
                            </p>
                          </td>
                          <td>
                            <p class="view-more-base-value">
                              {{ currentCustomerJson.customerMaker }}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p class="view-more-base-tag">
                              Account Type :
                            </p>
                          </td>
                          <td>
                            <p class="view-more-base-value">
                              {{ currentCustomerJson.accountType }}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p class="view-more-base-tag">
                              Account Class :
                            </p>
                          </td>
                          <td>
                            <p class="view-more-base-value">
                              {{ currentCustomerJson.accountClass }}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p class="view-more-base-tag">
                              Account Currency :
                            </p>
                          </td>
                          <td>
                            <p class="view-more-base-value">
                              {{ currentCustomerJson.accountCurrency }}
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <p class="view-more-base-tag">
                              Phone :
                            </p>
                          </td>
                          <td>
                            <p class="view-more-base-value">
                              {{ currentCustomerJson.customerPhoneNumber }}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p class="view-more-base-tag">
                              Email :
                            </p>
                          </td>
                          <td>
                            <p class="view-more-base-value">
                              {{
                                currentCustomerJson.customerEmail | toLowercase
                              }}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p class="view-more-base-tag">
                              Dob :
                            </p>
                          </td>
                          <td>
                            <p class="view-more-base-value">
                              {{
                                currentCustomerJson.customerDob | toLowercase
                              }}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p class="view-more-base-tag">
                              Address :
                            </p>
                          </td>
                          <td>
                            <p class="view-more-base-value">
                              {{
                                currentCustomerJson.customerAddress
                                  | toLowercase
                              }}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p class="view-more-base-tag">
                              State :
                            </p>
                          </td>
                          <td>
                            <p class="view-more-base-value">
                              {{
                                currentCustomerJson.customerState | toLowercase
                              }}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p class="view-more-base-tag">
                              Country :
                            </p>
                          </td>
                          <td>
                            <p class="view-more-base-value">
                              {{
                                currentCustomerJson.customerCountry
                                  | toLowercase
                              }}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p class="view-more-base-tag">
                              Bank Code :
                            </p>
                          </td>
                          <td>
                            <p class="view-more-base-value">
                              {{
                                currentCustomerJson.customerBankCode
                                  | toLowercase
                              }}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p class="view-more-base-tag">Branch Code :</p>
                          </td>
                          <td>
                            <p class="view-more-base-value">
                              {{
                                currentCustomerJson.customerBranchCode
                                  | toLowercase
                              }}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p class="view-more-base-tag">Signature :</p>
                          </td>
                          <td>
                            <p class="view-more-base-value">
                              <span>
                                <viewer
                                  :title="false"
                                  :options="imageViewerOptions"
                                  :images="[
                                    currentCustomerJson.customerMandate
                                  ]"
                                >
                                  <img
                                    :src="currentCustomerJson.customerMandate"
                                    alt=""
                                    class="customer-signature"
                                  />
                                </viewer>
                              </span>
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- end table-responsive -->
                </div>

                <p
                  v-if="currentCustomer.cqStatus === 'PENDING'"
                  class="text-right"
                >
                  <span
                    v-if="customer.moduleLoadingSeven"
                    class="formLoaderHold"
                  >
                    <BaseComponentLoader />
                  </span>
                  <span v-else>
                    <span class="reject-btn mr-2">
                      <button
                        @click="rejectChange()"
                        class="btn btn-light mr-1"
                      >
                        <i
                          class="dripicons-cross font-size-16 align-middle mr-2"
                        ></i>
                        Reject
                      </button>
                    </span>
                    <span class="authorize-btn">
                      <button
                        @click="authorizeChange()"
                        class="btn btn-primary mr-1"
                      >
                        <i
                          class="dripicons-checkmark font-size-16 align-middle mr-2"
                        ></i>
                        Authorize
                      </button>
                    </span>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vodal>

    <vodal
      :show="rejectModalOpen"
      :width="350"
      :height="300"
      measure="px"
      animation="zoom"
      @hide="rejectModalOpen = false"
      :closeOnClickMask="false"
      className="app-modal"
    >
      <div class="card">
        <div class="card-body">
          <!--          <h4 class="card-title mb-4">Customer Info</h4>-->
          <div>
            <div class="view-more-customer-info">
              <div class="view-more-customer-info-wrap">
                <div class="view-more-top">
                  <h4 class="card-title mb-2">Reject Reason</h4>
                  <span class="underground">{{ rejectModalOpen }}</span>
                </div>

                <div class="view-more-base">
                  <form @submit.prevent="rejectChangeFinal">
                    <div class="row">
                      <div class="col-sm-12">
                        <div>
                          <BaseInput
                            :inputType="'text'"
                            v-model="rejectVodalFormBody.rejectReason"
                            placeholder="Reason"
                            :hasPreIcon="false"
                            :label="'Reason'"
                            :class="{
                              error: $v.rejectVodalFormBody.rejectReason.$error
                            }"
                            @blur="$v.rejectVodalFormBody.rejectReason.$touch()"
                          >
                          </BaseInput>

                          <template
                            v-if="$v.rejectVodalFormBody.rejectReason.$error"
                          >
                            <p
                              v-if="
                                !$v.rejectVodalFormBody.rejectReason.required
                              "
                              class="form-error-message"
                            >
                              Reason is required
                            </p>
                          </template>
                        </div>
                      </div>

                      <p class="full-width text-right pr-2">
                        <span
                          v-if="branch.rejectLoading"
                          class="formLoaderHold"
                        >
                          <BaseComponentLoader />
                        </span>
                        <span v-else>
                          <button type="submit" class="btn btn-primary mr-1">
                            Reject
                          </button>
                        </span>
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vodal>
  </div>
</template>

<style scoped>
.view-customer-info-btn {
  position: relative;
  height: 20px;
  width: 20px;
  display: block;
  padding: 2px 2px;
  margin-top: 0;
  background-color: #795548;
  border-radius: 50%;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.15);
  cursor: pointer;
}
.view-customer-info-btn i {
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
}
p {
  color: #495057;
}
.underground {
  color: transparent;
}
</style>
